import { Directive, Input, ElementRef, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[alphabeticOnly]"
})
export class AlphabeticOnlyDirective {
constructor(private el: ElementRef) {}

private regex: RegExp = new  RegExp(/^[\p{L}\p{M}'\-\s]*$/u);


@HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!this.regex.test(input.value)) {
      input.value = input.value.replace(/[^\p{L}\p{M}'\-\s]/gu, ''); // Negated regex

    }
  }
}


